import cn from 'classnames';

import styles from '../../styles.module.scss';
import { useRedeemCouponContext, VARIANTS } from '../context';

export function Header({ children }) {
  const { variant, halfWidth } = useRedeemCouponContext();

  const className =
    variant === VARIANTS.large ? cn(styles.sectionContainer, { [styles.halfWidth]: halfWidth }) : '';

  return <div className={className}>{children}</div>;
}
